'use client';

import { c as _c } from "react/compiler-runtime";
import { TileCard } from './TileCard';
import { TileVideo } from './ui/tile-video';
interface SteveTileProps {
  className?: string;
  onClick?: () => void;
}
export default function SteveTile(t0) {
  const $ = _c(4);
  const {
    className,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TileVideo src="/images/craft/steve-optimized.mp4" posterSrc="/images/craft/steve-poster.jpg" title="Steve Jobs Timeline" className="size-full object-cover transition-transform group-hover:scale-105" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className || $[2] !== onClick) {
    t2 = <TileCard href="/steve" title="Steve Jobs Timeline" description="Homage to the greatest to ever do it" className={className} onClick={onClick}>{t1}</TileCard>;
    $[1] = className;
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}